import type { GridRowHeightParams } from '@mui/x-data-grid-pro';
import type { Highlight } from '@/widgets/cohortScanner';
import { ValueType } from '@/widgets/cohortScanner';
import { RowHeights } from '@/shared/constants';

export const getRowHeight =
  ({ rowHeight, highlight }: { rowHeight: RowHeights; highlight: Highlight }) =>
  (params: GridRowHeightParams) => {
    if (params.model.isTotal || highlight.valueType === ValueType.absolute) {
      return rowHeight;
    } else {
      switch (rowHeight) {
        case RowHeights.dense:
          return 38;
        case RowHeights.normal:
        case RowHeights.sparse:
        default:
          return 50;
      }
    }
  };
